import frMessages from "../locales/fr_FR.json";

const FrLang = {
  messages: {
    ...frMessages,
  },
  locale: "fr-FR",
};
export default FrLang;
